import { createContext } from "react";

export const UserContext = createContext(null);

export const SettingsContext = createContext(null);
